import _ from 'lodash'

const state = {
  show: false,
  message: 'Carregando ...'
}

const actions = {
  show ({ commit }, payload) {
    const isShow = _.get(payload, 'isShow', payload)
    const message = _.get(payload, 'message', 'Carregando ...')

    commit('setIsShow', isShow)
    commit('setMessage', message)
  }
}

const mutations = {
  setIsShow (state, isShow) {
    state.show = isShow
  },

  setMessage (state, message) {
    state.message = message
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
